import React from 'react';
import CompletedApprovalsComponent from '../CompletedApprovals';
import Heading from '@hubins/components/Heading';

const ApprovalsCompleted = () => {
  return (
    <>
      <Heading size="3" className='s-top-xl s-bottom-md'>Completed</Heading>
      <CompletedApprovalsComponent />
    </>
  );
};

export default ApprovalsCompleted;